<template>
  <div
    id="app"
    class="mpp-override"
  >
    <!-- <mainHeader /> -->
    <SessionTimer />
    <div :class="{ 'loading-wrapper': on_load, invisible: load_done }">
      <div class="loading-wave">
        <div
          class="loading-bar"
          :style="clientColor"
        />
        <div
          class="loading-bar"
          :style="clientColor"
        />
        <div
          class="loading-bar"
          :style="clientColor"
        />
        <div
          class="loading-bar"
          :style="clientColor"
        />
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
// import MainHeader from "./components/MainHeader"

import SessionTimer from "@/components/SessionTimer"
import axios from "axios";
import { API_URL } from "./api_url"
import { shouldUseMocks, mockGetTemplates } from "@/services/mock.service";

export default {
  name: 'App',

  components: {
    // MainHeader,
    SessionTimer
  },
  data() {
    return {
      on_load: true,
      load_done: false
    };
  },
  computed: {
    clientColor() {
      const { background_color } = this.$store.state.auth.jobFlowClient ?? {};
      if (!background_color) {
        return {}; // Return an empty object if background_color is not available
      }
      return {
        'backgroundColor': background_color
      };
    }
  },
  mounted() {
    this.on_load = true;
    this.load_done = false;

    if (!this.$store.state.auth.sessionId) {
      this.jwtLogin()
    } else {
      this.get_templates()
    }

    window.addEventListener("resize", this.send_height_to_parent_function); // whenever the page is resized
    window.addEventListener("readystatechange", this.send_height_to_parent_function); // whenever the page is resized
    var observer = new MutationObserver(this.send_height_to_parent_function); // whenever DOM changes PT1
    var config = { attributes: true, childList: true, characterData: true, subtree: true }; // PT2
    observer.observe(window.document, config); // PT3
  },
  methods: {
    async jwtLogin() {
      // Prüfen, ob Mock-Daten verwendet werden sollen
      if (shouldUseMocks()) {
        console.log("Using mock login");
        // Mock-Daten direkt in den Store setzen
        this.$store.commit("auth/login", {
          sessionId: "mock-session-12345",
          mailDomain: "example.com"
        });
        this.$store.commit("auth/setJobFlowClient", {
          background_color: "#3498db",
          text_color: "#ffffff"
        });
        this.$store.commit("auth/setClient", "example");
        this.$store.commit("auth/setSessionTimer", Math.floor(Date.now() / 1000) + 3600);
        this.get_templates();
      } else {
        // Echte API-Anfrage
        this.$store.dispatch("auth/login").then(
          () => { this.get_templates() },
          (err) => { }
        );
      }
    },
    get_templates() {
      console.log("getting templates");

      // Prüfen, ob Mock-Daten verwendet werden sollen
      const useMocks = shouldUseMocks();
      console.log("should use mocks:", useMocks);

      if (useMocks) {
        console.log("Using mock templates - before API call");
        mockGetTemplates()
          .then(data => {
            console.log("Mock templates loaded:", data.length);
            this.$store.state.app.templates = [...data];
            this.on_load = false;
            this.load_done = true;
          });

        // Wichtig: Early return hinzufügen, um sicherzustellen, dass der API-Aufruf nicht auch ausgeführt wird
        return;
      }

      // Echte API-Anfrage - nur ausgeführt, wenn useMocks === false
      console.log("Using real API for templates");
      axios.get(`https://${API_URL}/v1/templates`, { headers: { 'Authorization': this.$store.state.auth.sessionId } })
        .then(response => {
          console.log("API templates loaded:", response.data.length);
          this.$store.state.app.templates = [...response.data].slice(0, 500);
          this.on_load = false;
          this.load_done = true;
        })
        .catch(err => {
          console.error("API error:", err);
          this.jwtLogin();
        });
    },
    send_height_to_parent_function() {
      var element = document.querySelector("body");
      var height = element.offsetHeight;
      // console.log("Sending height as " + height + "px");
      parent.postMessage({ "height": height + 600 }, "*");
    },
    resizeIframe(iframe) {
      this.resizeItNowPrivate(iframe);
    },

    resizeIframeOnload() {
      let iframe = document.getElementById('healthy_behavior_iframe');
      iframe.onload = () => {
        this.resizeItNowPrivate(iframe);
      }
    },

    resizeItNowPrivate() {
      let iframe = document.getElementById('healthy_behavior_iframe');
      if (!iframe) return;
      // console.log("there's an iFrame")
      var body = iframe.contentWindow.document,
        html = iframe.contentWindow.document.documentElement;
      var height = Math.max(body.scrollHeight ?? 0, body.offsetHeight ?? 0,
        html.clientHeight ?? 0, html.scrollHeight ?? 0, html.offsetHeight ?? 0);
      if (height < 600) {
        height = 600;
      }
      iframe.style.height = height + 'px';
    }
  }
}
</script>
